import { useQuery } from "@tanstack/react-query";
import type {
  SpecialsManagerAPIInterfaceInternal,
  SpecialsManagerFetchInterface
} from "@dealer-center/ddc-pages-specials-manager-interface";

const queryKeyBase = "ddc-pages-specials-manager";

export function useSpecialsManagerAPIInterface({
  searchValue
}: SpecialsManagerFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { searchValue }],
    queryFn: () => getFunction(searchValue?.trim() || ""),
    enabled: !!searchValue && searchValue.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  searchValue: string
): Promise<SpecialsManagerAPIInterfaceInternal[]> => {
  const res = await fetch(
    "/landing/nxlambda/specialsManager/" + encodeURIComponent(searchValue)
  );
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
